<template>
    <div>
        <wap-header></wap-header>
        <!--内容-->
        <div>
            <div class="wap-product-detail" v-if="obj">
                <span class="wap-detail-title">产品详情</span>
                <div class="wap-detail-box">
                    <div class="wap-left">
                        <div class="imgs">
                            <img :src="require('@/assets/image/product/'+obj.image)" style="width:355px;">
                        </div>
                    </div>
                    <div class="wap-right">
                        <div class="right-box">
                            <h4>{{obj.title}}</h4>
                            <div class="jiben">
                                <span v-if="obj.name">产品名称：{{obj.name}}</span>
                                <span v-if="obj.CAS">CAS：{{obj.CAS}}</span>
                            </div>
                            <div v-if="obj.Industry==industrial? 'block': 'none'" class="Industry" >
                                <span v-if="obj.Industry.industrial">工业级：{{obj.Industry.industrial}}</span>
                                <span v-if="obj.Industry.appearance">外观：{{obj.Industry.appearance}}</span>
                                <span v-if="obj.Industry.purity">纯度：{{obj.Industry.purity}}</span>
                                <span v-if="obj.Industry.chloride">氯化氢含量：{{obj.Industry.chloride}}</span>
                                <span v-if="obj.Industry.packing">包装：{{obj.Industry.packing}}</span>
                                <span v-if="obj.Industry.weight">净重：{{obj.Industry.weight}}</span>
                                <span v-if="obj.Industry.purpose">用途：{{obj.Industry.purpose}}</span>
                            </div>
                            <div v-if="obj.Electronics" class="Industry">
                                <span v-if="obj.Electronics.electronic">电子级：{{obj.Electronics.electronic}}</span>
                                <span v-if="obj.Electronics.appearance">外观：{{obj.Electronics.appearance}}</span>
                                <span v-if="obj.Electronics.purity">纯度：{{obj.Electronics.purity}}</span>
                                <span v-if="obj.Electronics.packing">包装：{{obj.Electronics.packing}}</span>
                                <span v-if="obj.Electronics.weight">净重：{{obj.Electronics.weight}}</span>
                                <span v-if="obj.Electronics.purpose">用途：{{obj.Electronics.purpose}}</span>
                                <span v-if="obj.Electronics.chloroethanol">氯乙醇：{{obj.Electronics.chloroethanol}}</span>
                            </div>
                        </div>
                    </div>
                </div>
                <!--相关推荐-->
                <div style="margin-top: 24px">
                    <span class="wap-detail-title">相关推荐</span>
                    <div class="wap-listBox">
                        <div v-for="item in selectList" :key="item.id" class="wap-listBox-mini">
                            <div class="wap-lis" v-if="item.id!=obj.id" @click="to_detail(item.id)">
                                <div class="wap-listBox-imgs">
                                    <img :src="require('@/assets/image/product/'+item.image)" style="width:131px;margin-left:20px;">
                                </div>
                                <div class="name">{{item.name}}</div>
                            </div>
                        </div>
<!--                        <div style="clear: both"></div>-->
                    </div>
                </div>
            </div>
        </div>
        <wap-footer></wap-footer>
    </div>
</template>

<script>
    import wapHeader from "@/components/wap/headers";
    import wapFooter from "@/components/wap/footers";

    export default {
        name: "productWapDetail",
        components:{wapHeader,wapFooter},
        data(){
            return{
                obj: {
                    image:''
                },
                title: '',
                titleDetail: '',
                newEnergy: [],
                nitrileCompound: [],
                basics: [],
                selectList: [],

            }
        },
        watch:{},
        mounted() {
            this.getData(this.$route.query.id);
        },
        methods:{
            getData(id) {
                const newEnergy = this.newEnergy = require('../../../assets/JSONData/product/newEnergy.json');
                const nitrileCompound = this.nitrileCompound = require('../../../assets/JSONData/product/nitrileCompound.json');
                const basics = this.basics = require('../../../assets/JSONData/product/basics.json');
                let list = [];
                list = list.concat(newEnergy);
                list = list.concat(nitrileCompound)
                list = list.concat(basics);
                for (let i in list) {
                    if (list[i].id == id) {
                        this.obj = list[i];
                        if (this.obj.type == 1) {
                            this.title = '新能源材料'
                            this.selectList = this.newEnergy;
                        } else if (this.obj.type == 2) {
                            this.title = '腈类化合物及其衍生物'
                            this.selectList = this.nitrileCompound;
                        } else {
                            this.title = '基础化学品'
                            this.selectList = this.basics;
                        }
                        this.titleDetail = list[i].name
                    }
                }
            },
            to_detail(id) {
                this.getData(id)
            }
        }
    }
</script>

<style scoped>
    .wap-product-detail{
        width:355px;
        height:100%;
        margin:55px auto 0;
    }
    .wap-detail-title{
        font-size:17px;
        font-family: MicrosoftYaHei-Bold, MicrosoftYaHei;
        font-weight: bold;
        color: #363A44;
        text-align: left;
        display: block;
        border-left: 5px solid #0067AC;
        padding-left: 10px;
        margin-bottom: 10px;
    }
    .wap-left .imgs{
        width: 355px;
        height: 355px;
        background: #FFFFFF;
        border-radius: 10px;
        border: 2px solid #E6E8EB;
        overflow: hidden;
    }
    .wap-right .right-box h4{
        font-size: 19px;
        font-family: MicrosoftYaHei;
        color: #3A3A3A;
        font-weight: 400;
        padding-bottom: 20px;
        display: -webkit-box;
        display: -ms-flexbox;
        border-bottom: 1px solid #E6E8EB;
    }
    .wap-right .right-box .jiben{
        padding-top: 10px;
        padding-bottom: 7px;
    }
    .wap-right .right-box .jiben span{
        display: block;
        padding-bottom: 12px;
        font-size: 13px;
        font-family: MicrosoftYaHei;
        color: #3A3A3A;
    }
    .wap-right .right-box .Industry{
        border-top: 1px solid #E6E8EB;
        padding-top: 30px;
    }
    .wap-right .right-box .Industry span{
        display: block;
        padding-bottom: 12px;
        font-size: 13px;
        font-family: MicrosoftYaHei;
        color: #3A3A3A;
    }
    .wap-listBox{
        width:355px;
        min-height:172px;
        display: flex;
        flex-wrap: wrap;
        margin-bottom:30px;
    }
    .wap-lis{
        width: 167px;
        height: 168px;
        background: #FFFFFF;
        border-radius: 10px;
        border: 2px solid #E6E8EB;
        display: inline-block;
        position: relative;
        overflow: hidden;
        margin-right:3px;
        margin-left:3px;
    }
    .wap-lis .wap-listBox-imgs{
        height:131px;
        width: 167px;
        display: inline-block;
    }

    .wap-lis .name{
        width: 161px;
        height: 41px;
        background: #0067AC;
        display: inline-block;
        font-size: 13px;
        font-family: PingFangSC-Regular, PingFang SC;
        font-weight: 400;
        color: #FFFFFF;
        line-height: 35px;
        padding-left:6px;
        position: absolute;
        top:131px;
        left:0;
    }
    /*.wap-listBox-mini:nth-child(0){margin-right: 11px;}*/
    /*.wap-listBox-mini:nth-child(2){margin-right: 11px;}*/
    /*.wap-listBox-mini:nth-child(4){margin-right: 11px;}*/
</style>
